import { Observable } from 'rxjs/internal/Observable';
import { HttpEvent } from '@angular/common/http';

import { MessageService } from '../services/message.service';

import { AppInjector } from "../app.injector";

import { T as Trad } from '../tools/Traductions';

/**
 * Représente l'Observable pour la gestion des messages
 */
export class MessageObservable {
    static T: (clef, ...params) => string = Trad;

    /**
     * Operateur de gestion des messages
     */
    static MessageOperator() {
        return function messageOperatorImplementation(source: Observable<HttpEvent<any>>): Observable<any> {
            return Observable.create(subscriber => {

                const subscription = source.subscribe((value: any) => {
                    try {
                        // Si le retour contient des messages
                        if (value && value.body && value.body.StatusList && value.body.StatusList.length) {
                            // Gestion des messages
                            for (let i = 0; i < value.body.StatusList.length; i++) {
                                let message = value.body.StatusList[i];
                                let libelleMessage = message.Libelle;
                                let typeMessage = MessageObservable.obtenirTypeMessage(message.Etat);
                                AppInjector.get(MessageService).envoyerMessage(libelleMessage, typeMessage);
                            }
                        }
                        subscriber.next(value);
                    } catch (err) {
                        subscriber.error(err);
                    }
                },
                err => {
                    // Gestion de l'erreur
                    MessageObservable.gestionErreur(err);
                    subscriber.error(err);
                },
                () => subscriber.complete());

                return subscription;
            });
        }
    }

    /**
     * Gestion de l'erreur
     * @param err
     */
    private static gestionErreur(err: any): void {
        let libelleMessage = 'HTTP ' + err.status + ' - ' + this.T('message.erreur.http');
        AppInjector.get(MessageService).envoyerMessage(libelleMessage, 'danger');
    }

    /**
     * Obtenir le type de message
     * @param etat
     */
    private static obtenirTypeMessage(etat: string): string {
        if (etat == 'Bloquant') return 'danger';
        if (etat == 'Avertissement') return 'warning';
        if (etat == 'Information') return 'info';
        return 'primary';
    }
}

